<div class="agency-section"></div>

<div class="align-items-center flex justify-content-start">
  <div class="col-4">
    <div class="field">
      <label>Patient</label>
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon"><img alt="search.svg" src="../../assets/images/search.svg" /></span>
        <input
          (ngModelChange)="this.search.next($event)"
          [(ngModel)]="searchEsocPatient"
          [placeholder]="onlyAdminRoles() ? searchPatientById : searchPatientByMRN"
          class="table-search-field"
          type="text"
        />
      </div>
    </div>
  </div>
  <div class="col-3">
    <div class="field">
      <ng-container>
        <label>Case Manager</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img alt="search.svg" src="../../assets/images/search.svg" /></span>
          <input
            (ngModelChange)="this.search.next($event)"
            [(ngModel)]="searchByCaseManager"
            [placeholder]="searchByCaseManagerPlaceHolder"
            class="table-search-field w-full"
            type="text"
          />
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-3">
    <div class="field">
      <label>SOC Date</label>
      <div class="p-inputgroup table-calendar-wrapper">
        <span class="p-inputgroup-addon"><img alt="calendar.svg" src="assets/images/calendar.svg" /></span>
        <p-calendar
          (onClear)="onCalendarClear()"
          (onSelect)="selectVisitDate()"
          [(ngModel)]="rangeDates"
          [readonlyInput]="true"
          class="w-full"
          dateFormat="{{ datePickerFormat }}"
          inputId="range"
          placeholder="{{ datePickerPlaceholder }}"
          selectionMode="range"
        ></p-calendar>
        <button (click)="onCalendarClear()" *ngIf="rangeDates != null" class="clearBtn">
          <img alt="" src="assets/images/error.svg" />
        </button>
      </div>
    </div>
  </div>
</div>
<div class="table-wrapper">
  <div class="table-header">
    <div class="align-items-center flex">
      <div>
        <button
          pButton
          pRipple
          type="button"
          [disabled]="loading"
          class="p-button-rounded p-button-text reload-btn"
          (click)="geteSocPatientSubmissions()"
        ></button>
      </div>
      <h2 pTooltip="IO Doc allows agencies to send important patient documents electronically via email or text. This includes Patient Handbooks, Patient Information Reports (PIR), and other patient-facing documents without needing to print or mail physical copies." tooltipPosition="bottom">IO Documents</h2>
      <div class="user-label">
        <img alt="care.svg" src="../../assets/images/care.svg" />
        <span>{{ totalEsocs }}</span>
      </div>
    </div>
    <div class="flex">
      <!--        <div class="p-buttonset flex">-->
      <!--            <button [routerLink]="['/e-docs']" label="ePatient Handbook" pButton pRipple></button>-->
      <!--            <button [routerLink]="['invoices']" label="Invoices" pButton pRipple></button>-->
      <!--            <button [routerLink]="['others']" label="Others" pButton pRipple></button>-->
      <!--        </div>-->
      <div class="m-l-24">
        <p-button
          (onClick)="uploadOthersDisplay = true"
          *ngIf="currentRoute == '/e-docs/others'"
          label="Upload Document"
          styleClass="button-sm add-icon"
        ></p-button>
      </div>
    </div>
    <!--          <div class="align-items-center flex">-->
    <!--            <p-dropdown [(ngModel)]="selectRefreshTime" [options]="refreshTime"  (onChange)="onChangeRefreshTime()"></p-dropdown>-->
    <!--          </div>-->
    <!--    <div *ngIf="this.currentUser?.currentUserRole == Admin || (this.currentUser?.currentUserRole == agencyAdmin && !this.currentUser?.is_ioh_user )">-->
    <div>
      <p-button (onClick)="exportReport()" label="Export Report" styleClass="button-sm"></p-button>
    </div>
  </div>
  <router-outlet></router-outlet>
  <p-table
    #dt
    (onLazyLoad)="customSort($event)"
    *ngIf="currentRoute == '/e-docs'"
    [(selection)]="selectedPatients"
    [customSort]="true"
    [lazy]="true"
    [rowHover]="true"
    [value]="esocPatientsData"
    dataKey="id"
    styleClass="edoc-table-wrapper"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th class="w-10rem" pSortableColumn="SOCDate" id="socDate">SOC Date<p-sortIcon field="SOCDate"></p-sortIcon></th>
        <th pSortableColumn="createdAt" id="createdAt">Created At<p-sortIcon field="createdAt"></p-sortIcon></th>
        <!--            <th pSortableColumn="submittedBy">Submitted by</th>-->
        <!--            <th pSortableColumn="caseManager">-->
        <!--              <div class="flex align-items-center gap-2">-->
        <!--                <span>Case Manager</span>-->
        <!--                &lt;!&ndash; <div class=" filterClass" *ngIf="showcasemanagerNameFilter">-->
        <!--                  <i class="pi pi-filter" (click)="dropdown.show()"></i>-->
        <!--                  <p-dropdown #dropdown [(ngModel)]="selectedCaseManager" [autoDisplayFirst]="false"  [options]="caseManagerFilterNames" (onChange)="onSelectedCaseManagerName()"></p-dropdown>-->
        <!--                </div> &ndash;&gt;-->
        <!--              </div>-->
        <!--            </th>-->
        <th id="patient">
          <div class="flex align-items-center gap-2">
            <span>Patient</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="consent === 'ALL'" (click)="dropdown.show()" src="assets/images/filter-outline.svg" />
              <img class="w-18" *ngIf="consent == false || consent !== 'ALL'" (click)="dropdown.show()" src="assets/images/filter-filled.svg" />
              <p-dropdown
                #dropdown
                (onChange)="consentStatusChange()"
                [(ngModel)]="consent"
                [autoDisplayFirst]="false"
                [options]="consentStatus"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <!--            <th pSortableColumn="sentVia">Preferred Delivery</th>-->
        <th>
          <div class="flex align-items-center gap-2">
            <span pTooltip="Patient Handbook (PH) contains the agency's required Start of Care documentation that must be provided to the patient. This typically includes patient rights, responsibilities, agency policies, and other required SOC materials." tooltipPosition="top">Patient Handbook</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="!fileStatus" (click)="ephdropdown.show()" src="assets/images/filter-outline.svg" />
              <img class="w-18" *ngIf="fileStatus" (click)="ephdropdown.show()" src="assets/images/filter-filled.svg" />
              <p-dropdown
                #ephdropdown
                (onChange)="onStatusChange($event, fileType.file); piReportStatus = ''; otherStatus = ''"
                [(ngModel)]="fileStatus"
                [autoDisplayFirst]="false"
                [options]="statusOptions"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th>
          <div class="flex align-items-center gap-2">
            <span pTooltip="Patient Information Report (PIR) is a report generated from the HCHB R2 back office system. It is typically produced through workflow automation or from within the patient's chart when updates occur in the patient's Plan of Care." tooltipPosition="top">PIReport</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="!piReportStatus" (click)="piReportDropdown.show()" src="assets/images/filter-outline.svg" />
              <img class="w-18" *ngIf="piReportStatus" (click)="piReportDropdown.show()" src="assets/images/filter-filled.svg" />
              <p-dropdown
                #piReportDropdown
                (onChange)="onStatusChange($event, fileType.piReportFile); fileStatus = ''; otherStatus = ''"
                [(ngModel)]="piReportStatus"
                [autoDisplayFirst]="false"
                [options]="statusOptions"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th>
          <div class="flex align-items-center gap-2">
            <span pTooltip="Other Documents includes any additional files the agency wishes to send to the patient, such as patient instructions, billing information, educational materials, or other documentation related to care." tooltipPosition="top">Other Documents</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="!otherStatus" (click)="othersDropdown.show()" src="assets/images/filter-outline.svg" />
              <img class="w-18" *ngIf="otherStatus" (click)="othersDropdown.show()" src="assets/images/filter-filled.svg" />
              <p-dropdown
                #othersDropdown
                (onChange)="onStatusChange($event, fileType.otherFile); fileStatus = ''; piReportStatus = ''"
                [(ngModel)]="otherStatus"
                [autoDisplayFirst]="false"
                [options]="statusOptions"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th id="patient">
          <div class="flex align-items-center gap-2">
            <span pTooltip="IO Doc allows agencies to send important patient documents electronically via email or text. This includes Patient Handbooks, Patient Information Reports (PIR), and other patient-facing documents without needing to print or mail physical copies." tooltipPosition="top">IO Doc.</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="edocCompleteStatus === 'ALL'" (click)="dropdownedoc.show()" src="assets/images/filter-outline.svg" />
              <img
                class="w-18"
                *ngIf="edocCompleteStatus == false || edocCompleteStatus !== 'ALL'"
                (click)="dropdownedoc.show()"
                src="assets/images/filter-filled.svg"
              />
              <p-dropdown
                #dropdownedoc
                (onChange)="consentStatusChange()"
                [(ngModel)]="edocCompleteStatus"
                [autoDisplayFirst]="false"
                [options]="edocComplete"
                appendTo="body"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th pSortableColumn="" id=""></th>
      </tr>
    </ng-template>
    <ng-template let-esocPatientsData let-rowIndex="rowIndex" pTemplate="body">
      <tr class="p-selectable-row">
        <td (click)="openEPHUploadPopup(rowIndex, fileType.file)">
          {{ esocPatientsData?.patientEsocData?.SOCDate | customDate: dateFormat }}
        </td>
        <td (click)="openEPHUploadPopup(rowIndex, fileType.file)">
          {{ esocPatientsData?.patientEsocData?.createdAt | customDate: dateFormat }}
        </td>
        <!--            <td>-->
        <!--              {{esocPatientsData?.UserfirstName}} {{esocPatientsData?.UserlastName}}-->
        <!--              <p class="gc-agency-handle">{{ esocPatientsData?.UserdefaultRole ? '(' + RoleEnum[esocPatientsData?.UserdefaultRole] + ')' : esocPatientsData?.isSuperAdmin ? '(' + RoleEnum.SUPER_ADMIN + ')' : esocPatientsData?.isIohAdmin ? '(' + RoleEnum.IOH_ADMIN + ')' : '' }}</p>-->
        <!--            </td>-->
        <!--            <td>-->
        <!--              {{esocPatientsData?.patientEsocData?.patient?.CaseManagerFirstName}} {{esocPatientsData?.patientEsocData?.patient?.CaseManagerLastName}}-->
        <!--            </td>-->
        <td (click)="openEPHUploadPopup(rowIndex, fileType.file)">
          <div *ngIf="!hidePatientName" class="flex align-items-center gap-2">
            <!--                <div class="gc-agency-img">-->
            <!--                  <app-avatar [firstName]="esocPatientsData.patient.firstName" [lastName]="esocPatientsData.patient.lastName"></app-avatar>-->
            <!--                </div>-->
            <div>
              <p *ngIf="esocPatientsData?.patientName" class="gc-agency-name">
                {{ esocPatientsData.patientName | truncate: defaultMrnLength }}
                <!--                  {{(esocPatientsData?.patientEsocData?.patient?.firstName + " " + esocPatientsData?.patientEsocData?.patient?.lastName) | truncate: defaultMrnLength}}-->
              </p>
              <p class="gc-agency-handle">
                {{ esocPatientsData?.patientEsocData?.patient?.mrn | truncate: defaultMrnLength }}
              </p>
              <!-- <div>{{esocPatientsData?.patient?.firstName}} {{esocPatientsData?.patient?.lastName}}</div>-->
              <!-- <div class="MRN-id">{{ ( 'MRN: ' + esocPatientsData?.patient?.mrn )| truncate: defaultMrnLength }}</div>-->
            </div>

            <div *ngIf="currentAgencyRole.role == iohAdmin || currentAgencyRole.role == Admin" class="">
              <span [escape]="false" [pTooltip]="createTooltip(esocPatientsData)" class="tooltip-icon" tooltipStyleClass="eSocMRNToolTip">
                <img alt="exclamation.svg" src="assets/images/exclamation.svg"
              /></span>
            </div>
          </div>
          <div *ngIf="hidePatientName" class="flex gap-1">
            <span class="MRN-id w-165">{{ esocPatientsData?.patientEsocData?.patient?._id | truncate: defaultMrnLength }}</span>
            <div *ngIf="currentAgencyRole.role == iohAdmin || currentAgencyRole.role == Admin" class="">
              <span [escape]="false" [pTooltip]="createTooltip(esocPatientsData)" class="tooltip-icon" tooltipStyleClass="eSocMRNToolTip">
                <img alt="exclamation.svg" src="assets/images/exclamation.svg"
              /></span>
            </div>
          </div>
        </td>
        <!--            <td>-->
        <!--              <div class="flex gap-3 align-items-center">-->
        <!--                <img *ngIf="esocPatientsData?.patientEsocData?.eSocEmailPhonePreference?.email?.preferred" alt="" src="assets/images/email-icn.svg">-->
        <!--                <img *ngIf="esocPatientsData?.patientEsocData?.eSocEmailPhonePreference?.phone?.preferred" alt="" src="assets/images/phone-icon.svg">-->
        <!--              </div>-->
        <!--              <span *ngIf="!(esocPatientsData?.patientEsocData?.eSocEmailPhonePreference?.phone?.preferred || esocPatientsData?.patientEsocData?.eSocEmailPhonePreference?.email?.preferred)">N/A</span>-->
        <!--            </td>-->
        <td>
          <div class="flex">
            <button (click)="openEPHUploadPopup(rowIndex, fileType.file)" class="p-button eph-button">
              <img
                [src]="
                  esocPatientsData?.patientEsocData?.file && esocPatientsData?.patientEsocData?.file?.length
                    ? 'assets/images/update.svg'
                    : 'assets/images/upload-eph.svg'
                "
                alt="Update"
              />
              <span>{{ esocPatientsData?.patientEsocData?.file && esocPatientsData?.patientEsocData?.file?.length ? 'Update' : 'Upload' }}</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.file)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.file &&
                esocPatientsData?.patientEsocData?.file.length &&
                esocPatientsData?.patientEsocData?.sendEsocCounter < 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button eph-send-btn"
            >
              <img alt="Send" src="assets/images/send.svg" />
              <span>Send</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.file)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.file &&
                esocPatientsData?.patientEsocData?.file.length &&
                esocPatientsData?.patientEsocData?.sendEsocCounter >= 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button resendButton"
            >
              <img alt="Resend" src="assets/images/resend-eph.svg" />
              <span>Resend</span>
            </button>
          </div>
        </td>
        <td>
          <div class="flex">
            <button (click)="openEPHUploadPopup(rowIndex, fileType.piReportFile)" class="p-button eph-button">
              <img
                [src]="
                  esocPatientsData?.patientEsocData?.piReportFile && esocPatientsData?.patientEsocData?.piReportFile?.length
                    ? 'assets/images/update.svg'
                    : 'assets/images/upload-eph.svg'
                "
                alt="Update"
              />
              <span>{{
                esocPatientsData?.patientEsocData?.piReportFile && esocPatientsData?.patientEsocData?.piReportFile?.length ? 'Update' : 'Upload'
              }}</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.piReportFile)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.piReportFile &&
                esocPatientsData?.patientEsocData?.piReportFile.length &&
                esocPatientsData?.patientEsocData?.sendpiReportFileCounter < 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button eph-send-btn"
            >
              <img alt="Send" src="assets/images/send.svg" />
              <span>Send</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.piReportFile)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.piReportFile &&
                esocPatientsData?.patientEsocData?.piReportFile.length &&
                esocPatientsData?.patientEsocData?.sendpiReportFileCounter >= 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button resendButton"
            >
              <img alt="Resend" src="assets/images/resend-eph.svg" />
              <span>Resend</span>
            </button>
          </div>
        </td>
        <td>
          <div class="flex">
            <button (click)="openEPHUploadPopup(rowIndex, fileType.otherFile)" class="p-button eph-button">
              <img
                [src]="
                  esocPatientsData?.patientEsocData?.otherFile && esocPatientsData?.patientEsocData?.otherFile?.length
                    ? 'assets/images/update.svg'
                    : 'assets/images/upload-eph.svg'
                "
                alt="Update"
              />
              <span>{{
                esocPatientsData?.patientEsocData?.otherFile && esocPatientsData?.patientEsocData?.otherFile?.length ? 'Update' : 'Upload'
              }}</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.otherFile)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.otherFile &&
                esocPatientsData?.patientEsocData?.otherFile.length &&
                esocPatientsData?.patientEsocData?.sendOtherFileCounter < 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button eph-send-btn"
            >
              <img alt="Send" src="assets/images/send.svg" />
              <span>Send</span>
            </button>

            <button
              (click)="processEsocRequest(rowIndex, fileType.otherFile)"
              *ngIf="
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent &&
                esocPatientsData?.patientEsocData?.otherFile &&
                esocPatientsData?.patientEsocData?.otherFile.length &&
                esocPatientsData?.patientEsocData?.sendOtherFileCounter >= 1 &&
                esocPatientsData?.patientEsocData?.patient?.contactInfo?.consent
              "
              class="p-button eph-button resendButton"
            >
              <img alt="Resend" src="assets/images/resend-eph.svg" />
              <span>Resend</span>
            </button>
          </div>
        </td>
        <td>
          {{
            esocPatientsData?.patientEsocData?.eDocComplete === true
              ? 'Complete'
              : esocPatientsData?.patientEsocData?.eDocComplete === false
              ? 'Incomplete'
              : ''
          }}
        </td>
        <td>
          <button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" mat-icon-button>
            <mat-icon>more_horiz</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="esoc-option-menu">
            <button
              (click)="downloadEsocPatient(rowIndex, fileType.file)"
              [disabled]="!(esocPatientsData?.patientEsocData?.file && esocPatientsData?.patientEsocData?.file.length >= 1)"
              mat-menu-item
            >
              <span class="mat-opi-icon">
                <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.99996 8.66667L2.66663 5.33334L3.59996 4.36667L5.33329 6.10001V0.666672H6.66663V6.10001L8.39996 4.36667L9.33329 5.33334L5.99996 8.66667ZM0.666626 11.3333V8.00001H1.99996V10H9.99996V8.00001H11.3333V11.3333H0.666626Z"
                  />
                </svg>
              </span>
              <span pTooltip="Patient Handbook (PH) contains the agency's required Start of Care documentation that must be provided to the patient." tooltipPosition="left">Download PH File</span>
            </button>
            <button
              (click)="downloadEsocPatient(rowIndex, fileType.piReportFile)"
              [disabled]="!(esocPatientsData?.patientEsocData?.piReportFile && esocPatientsData?.patientEsocData?.piReportFile.length >= 1)"
              mat-menu-item
            >
              <span class="mat-opi-icon">
                <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.99996 8.66667L2.66663 5.33334L3.59996 4.36667L5.33329 6.10001V0.666672H6.66663V6.10001L8.39996 4.36667L9.33329 5.33334L5.99996 8.66667ZM0.666626 11.3333V8.00001H1.99996V10H9.99996V8.00001H11.3333V11.3333H0.666626Z"
                  />
                </svg>
              </span>
              <span pTooltip="Patient Information Report (PIR) is a report generated from the HCHB R2 back office system." tooltipPosition="left">Download PIReport File</span>
            </button>
            <button
              (click)="downloadEsocPatient(rowIndex, fileType.otherFile)"
              [disabled]="!(esocPatientsData?.patientEsocData?.otherFile && esocPatientsData?.patientEsocData?.otherFile.length >= 1)"
              mat-menu-item
            >
              <span class="mat-opi-icon">
                <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M5.99996 8.66667L2.66663 5.33334L3.59996 4.36667L5.33329 6.10001V0.666672H6.66663V6.10001L8.39996 4.36667L9.33329 5.33334L5.99996 8.66667ZM0.666626 11.3333V8.00001H1.99996V10H9.99996V8.00001H11.3333V11.3333H0.666626Z"
                  />
                </svg>
              </span>
              <span pTooltip="Other Documents includes any additional files the agency wishes to send to the patient." tooltipPosition="left">Download Other File</span>
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No IO Document found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div *ngIf="currentRoute == '/e-docs'">
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfEsocksPerRow"
      [totalRecords]="totalEsocs"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<app-esoc-upload
  (eSocPopUpClose)="ePHUploadPopupClose()"
  (eSockUploadListingRefresh)="refreshListing($event)"
  *ngIf="eSOCUploadDisplay"
  [currentUserRole]="currentUser.currentUserRole"
  [eSOCDeleteType]="eSOCUploadType"
  [eSOCUploadDisplay]="eSOCUploadDisplay"
  [eSOCUploadType]="eSOCUploadType"
  [patientSubmission]="selectedEsock"
  [userId]="currentUser._id"
>
</app-esoc-upload>

<app-others-upload (othersPopUpClose)="uploadOthersDisplay = false" *ngIf="uploadOthersDisplay"> </app-others-upload>
